export const EMAIL_SMS_ENUM = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  Email: 'Email',
  sms: 'sms',
};
